import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "ya-header"
};
var _hoisted_2 = {
  class: "ya-header-left"
};
var _hoisted_3 = {
  class: "ya-header-left-avatar"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "ya-header-left-info-nickname"
};
var _hoisted_6 = {
  class: "ya-header-left-info-text"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  key: 1,
  class: "ya-header-left-info"
};
var _hoisted_9 = {
  class: "ya-header-left-info-nickname"
};
var _hoisted_10 = {
  class: "ya-header-left-info-text"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "ya-header-left-info-text-lint"
}, null, -1);
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "ya-header-right"
};
var _hoisted_14 = ["src"];
var _hoisted_15 = ["src"];
var _hoisted_16 = {
  key: 0,
  class: "ya-header-right-tip-num"
};
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getNotificationInAppCategory } from '@/models/api/yourAccountApi.js';
import { Bridge } from '@/utils/bridge';
import { isLoginAuthenticated } from '@/utils/common';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { NOT_AUTHORIZE_LOGIN_PATH } from './../constants';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
var ROUTE_NAME = 'yoCustomerReview';
var ACCOUNT_SETTINGS_PAGE_ROUTER = 'accountSettings';
var MESSAGE_CENTER_PAGE_ROUTER = 'messageCenter';
export default {
  __name: 'YAHeader',
  props: {
    isLogin: Boolean,
    customerReviewCount: Object
  },
  emits: ['update:isLogin'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    useLess('views/yourAccount/components/YAHeader.less');
    var IMAGE_URL = constants.IMAGE_URL;
    var UNREAD_QUANTITY_RANGE = constants.UNREAD_QUANTITY_RANGE,
      UNREAD_QUANTITY_RANGE_MARK = constants.UNREAD_QUANTITY_RANGE_MARK,
      ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP = constants.ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP,
      ENCRYPTED_MARKETPLACE_ID = constants.ENCRYPTED_MARKETPLACE_ID;
    var ROUTE_PARAMETER_ENUM = Object.freeze({
      // 0-To be evaluate 1-Evaluated
      TO_BE_EVALUATED: 0,
      EVALUATED: 1
    });
    var ICON_ENUM = {
      MY_AVATAR: constants.MY_AVATAR,
      NOTIFICATION_RING: `${IMAGE_URL}assets/svg/msgIcon.svg`,
      SETTING: `${IMAGE_URL}assets/svg/settingIcon.svg`,
      RIGHT_ARROW: `${IMAGE_URL}assets/image/mine-icon/right_regular.png`
    };
    var unreadMessageNumber = ref(0);
    var router = useRouter();
    var userName = ref('');
    var jumpToPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(path, reviewStatus) {
        var isLoginStatus;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (path === ACCOUNT_SETTINGS_PAGE_ROUTER) {
                awsRumHandler.recordClickEvent(clickEvents.yourAccountPage.goToSettingsButton);
              }
              if (NOT_AUTHORIZE_LOGIN_PATH.includes(path)) {
                _context.next = 10;
                break;
              }
              _context.next = 4;
              return isLoginAuthenticated();
            case 4:
              _context.next = 6;
              return isLoginAuthenticated(false);
            case 6:
              isLoginStatus = _context.sent;
              emit('update:isLogin', isLoginStatus);
              if (isLoginStatus) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              if (path === ROUTE_NAME) {
                router.push({
                  name: path,
                  params: {
                    reviewStatus
                  }
                });
              } else {
                router.push({
                  name: path
                });
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function jumpToPage(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    var getUnreadMessageQuantity = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$getNotificatio, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getNotificationInAppCategory({
                language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID]
              });
            case 2:
              _yield$getNotificatio = _context2.sent;
              data = _yield$getNotificatio.data;
              unreadMessageNumber.value = (data === null || data === void 0 ? void 0 : data.unreadCount) || 0;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getUnreadMessageQuantity() {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(() => props.isLogin, isLogin => {
      if (isLogin) {
        Bridge.callFn('getCurrentUserInfo', null, infor => {
          var name = infor.name;
          userName.value = name || '';
        });
        getUnreadMessageQuantity();
      }
    }, {
      immediate: true
    });
    var login = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              awsRumHandler.recordClickEvent(clickEvents.yourAccountPage.loginButton);
              _context3.next = 3;
              return isLoginAuthenticated();
            case 3:
              _context3.t0 = emit;
              _context3.next = 6;
              return isLoginAuthenticated(false);
            case 6:
              _context3.t1 = _context3.sent;
              (0, _context3.t0)('update:isLogin', _context3.t1);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function login() {
        return _ref3.apply(this, arguments);
      };
    }();
    return (_ctx, _cache) => {
      var _props$customerRevie, _props$customerRevie2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: ICON_ENUM.MY_AVATAR,
        draggable: "false"
      }, null, 8, _hoisted_4)]), !__props.isLogin ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: login,
        class: "ya-header-left-info"
      }, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('modules.yourAccount.WELCOME_YOU')), 1), _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.$t('modules.yourAccount.LOGIN_AND_REGISTRATION')), 1), _createElementVNode("img", {
        src: ICON_ENUM.RIGHT_ARROW,
        class: "ya-header-left-info-text-icon",
        draggable: "false"
      }, null, 8, _hoisted_7)])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(userName.value), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", {
        onClick: _cache[0] || (_cache[0] = $event => jumpToPage(ROUTE_NAME, _unref(ROUTE_PARAMETER_ENUM).EVALUATED))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.yourAccount.COMMENTED')) + " ", 1), _withDirectives(_createElementVNode("span", null, _toDisplayString(__props.customerReviewCount.commmentedCount), 513), [[_vShow, (_props$customerRevie = __props.customerReviewCount) === null || _props$customerRevie === void 0 ? void 0 : _props$customerRevie.commmentedCount]])]), _hoisted_11, _createElementVNode("p", {
        onClick: _cache[1] || (_cache[1] = $event => jumpToPage(ROUTE_NAME, _unref(ROUTE_PARAMETER_ENUM).TO_BE_EVALUATED))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.yourAccount.TO_EVALUATE')) + " ", 1), _withDirectives(_createElementVNode("span", null, _toDisplayString(__props.customerReviewCount.toBeCommentedCount), 513), [[_vShow, (_props$customerRevie2 = __props.customerReviewCount) === null || _props$customerRevie2 === void 0 ? void 0 : _props$customerRevie2.toBeCommentedCount]])]), _createElementVNode("img", {
        src: ICON_ENUM.RIGHT_ARROW,
        class: "ya-header-left-info-text-icon",
        draggable: "false"
      }, null, 8, _hoisted_12)])]))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: "ya-header-right-tip",
        onClick: _cache[2] || (_cache[2] = $event => jumpToPage(ACCOUNT_SETTINGS_PAGE_ROUTER))
      }, [_createElementVNode("img", {
        src: ICON_ENUM.SETTING,
        draggable: "false"
      }, null, 8, _hoisted_14)]), _createElementVNode("div", {
        class: "ya-header-right-tip",
        onClick: _cache[3] || (_cache[3] = $event => jumpToPage(MESSAGE_CENTER_PAGE_ROUTER))
      }, [_createElementVNode("img", {
        src: ICON_ENUM.NOTIFICATION_RING,
        draggable: "false"
      }, null, 8, _hoisted_15), unreadMessageNumber.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(unreadMessageNumber.value > _unref(UNREAD_QUANTITY_RANGE) ? _unref(UNREAD_QUANTITY_RANGE_MARK) : unreadMessageNumber.value), 1)) : _createCommentVNode("", true)])])]);
    };
  }
};